// extracted by mini-css-extract-plugin
export var container = "videos-module--container--777fe";
export var subscribe = "videos-module--subscribe--788c3";
export var subscribeBlock = "videos-module--subscribe-block--3d745";
export var subscribeBlockYellow = "videos-module--subscribe-block-yellow--cc221";
export var video = "videos-module--video--5f257";
export var videoBlock = "videos-module--video-block--dd2d4";
export var videoDate = "videos-module--video-date--2e220";
export var videoTitle = "videos-module--video-title--13693";
export var videosContainer = "videos-module--videos-container--a1287";